import DelegationStatement from '../../../pages/delegationOfAuthority/v2/components/DelegationStatement/DelegationStatement';
import styles from '../../../pages/delegationOfAuthority/v2/containers/DelegationOfAuthorityV2.scss';
import { Button, BUTTON } from 'components/common/Button/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { createNewBinderPredicate } from 'common/permissions/predicates';

export const bindersInitialStateV4 = (binderType, handleCreateBinderBtnClicked) => {
    return (
        <DelegationStatement className={styles.newInitialStateContainer}>
            <div className={styles.centeredContainer}>
                <p className={styles.zeroStateBinderText}>{`Let's create your first ${binderType} Binder!`}</p>
                <div className={styles.buttonContainer}>
                    {
                        createNewBinderPredicate && (
                            <Button
                                bgcolor={BUTTON.BGCOLOR.BLUE}
                                color={BUTTON.COLOR.WHITE}
                                onClick={handleCreateBinderBtnClicked}
                            >
                                <FontAwesomeIcon icon={faPlus} className={styles.actionIcon} />
                                Create Binder
                            </Button>
                        )
                    }
                    
                </div>
            </div>
        </DelegationStatement>
    );
};

export const bindersInitialStateV4NoAccess = (binderType) => {
    return (
        <DelegationStatement className={styles.newInitialStateContainer}>
            <div className={styles.centeredContainer}>
                <p className={styles.zeroStateBinderText}>{`You do not have access to any ${binderType} Binders.`}</p>
            </div>
        </DelegationStatement>
    );
};
